"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recurseContainerContent = exports.getContentLists = exports.isContentContainer = void 0;
var content_containers_1 = require("../../models/content/content-containers");
var content_helpers_1 = require("./content.helpers");
function isContentContainer(item) {
    return (item === null || item === void 0 ? void 0 : item.typeDescriptor) === content_containers_1.ContentContainerKey;
}
exports.isContentContainer = isContentContainer;
function getContentLists(content) {
    // eslint-disable-next-line no-prototype-builtins
    if (content === null || content === void 0 ? void 0 : content.hasOwnProperty('data')) {
        return recurseContainerContent((0, content_helpers_1.asContentArray)(content));
    }
    return content && recurseContainerContent([content]);
}
exports.getContentLists = getContentLists;
function recurseContainerContent(contentArray) {
    var result = [];
    contentArray.forEach(function (content) {
        if (isContentContainer(content)) {
            content.translations.forEach(function (translation) {
                result.push.apply(result, recurseContainerContent((0, content_helpers_1.asContentArray)(translation)));
            });
        }
        else {
            result.push(content);
        }
    });
    return result;
}
exports.recurseContainerContent = recurseContainerContent;
//# sourceMappingURL=content-list.helpers.js.map